import React from 'react';
import Themes from '../Themes';
import translations from '../../translations';

function DemoVenue() {
  const [language, setLanguage] = React.useState(localStorage.getItem('language') || 'en');
  const t = translations[language];
  const localStorageTheme = localStorage.getItem('theme');
  const localStorageLocation = localStorage.getItem('location');
  const localStorageStartTime = localStorage.getItem('start_time');
  const localStorageEndTime = localStorage.getItem('end_time');
  const localStorageWeddingDate = localStorage.getItem('wedding_date'); 
  const selectedfontP = localStorage.getItem('fontP');

  const theme = (localStorageTheme || "theme6");
  const Components = Themes[theme];

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const location = localStorageLocation || "Corus Hotel, Kuala Lumpur";
  const streetAddress = localStorage.getItem('streetAddress') || 'Persiaran Hampshire, Jalan Ampang'
  const city = localStorage.getItem('city') || 'Kuala Lumpur';
  const state = localStorage.getItem('state') || 'Kuala Lumpur';
  const postcode = localStorage.getItem('postcode') || '50450'; 
  const startTime = localStorageStartTime || "11:30";
  const endTime = localStorageEndTime || "17:00";

  function convertTo12HourFormat(time24) {
    const [hours, minutes] = time24.split(":");
    const period = hours >= 12 ? "pm" : "am";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
  
    return `${hours12}:${minutes} ${period}`;
  }

  const startTimeNew = convertTo12HourFormat(startTime);
  const endTimeNew = convertTo12HourFormat(endTime);

  const weddingDate = localStorageWeddingDate ? new Date(localStorageWeddingDate) : tomorrow;
  const formattedDate = weddingDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const weddingDay = getDayFromDate(weddingDate);

  function getDayFromDate(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayIndex = date.getDay();
    localStorage.setItem('Day', days[dayIndex]);
    return days[dayIndex];
  }

  const fontP = (selectedfontP || Components.fontP);

  return (
    <div className="text-center pt-10 pb-20 md:w-3/5 w-4/5 mx-auto">
      <h1 className={`text-l mt-8 mb-4 uppercase font-bold ${fontP}`}>{t.location}</h1>
      {location && <span className="block">{location}</span>}
      {streetAddress && <span className="block">{streetAddress}</span>}
      {postcode && city && <span className="block">{postcode}, {city}</span>}
      {state && <span className="block">{state}</span>}

      <h1 className={`text-l mt-8 mb-4 uppercase font-bold ${fontP}`}>{t.date}</h1>
      <p className={`text-l ${fontP}`}>{weddingDay}, {formattedDate}</p>

      <h1 className={`text-l mt-8 mb-4 uppercase font-bold ${fontP}`}>{t.time}</h1>
      <p className={`text-l ${fontP}`}>{startTimeNew} - {endTimeNew}</p>
    </div>
  );
}

export default DemoVenue;
